import { render, staticRenderFns } from "./DeleteCollectionFolderModal.vue?vue&type=template&id=a5065706&lang=pug&"
import script from "./DeleteCollectionFolderModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCollectionFolderModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteCollectionFolderModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports